import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgDog = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 44 50", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.55,
      d: "M27.303.097v.005c-.055 0-.112-.005-.168-.005-7.6-.763-16.478 2.857-16.234 12.113.046 1.8.776 3.542 2.12 4.731.865.766 1.861 1.233 3.04 1.3h.278a11.037 11.037 0 0 0 1.371 3.373c-5.817 3.327-11.167 8.028-12.014 16.59-.014.135-.02.271-.02.405l-.012 1.414c-2.819-.546-3.751-4.107-4.048-6.83-.071-.645-.975-.696-1.123-.062-.9 3.864-1.24 10.35 5.111 13.885a2.921 2.921 0 0 0 2.913 2.955h5.456a2.922 2.922 0 0 0 2.913-2.93v-1.385c0 2.383 1.92 4.315 4.292 4.315h1.673c2.37 0 4.291-1.932 4.291-4.315v-.206c0 2.494 2.014 4.52 4.497 4.52h1.334c2.67 0 4.835-2.176 4.835-4.86V28.513c0-1.325-.35-2.626-1.017-3.77l-1.1-1.893h-.005a11.103 11.103 0 0 0 2.246-4.606h.453c1.179-.067 2.175-.535 3.04-1.3 1.344-1.19 2.074-2.931 2.12-4.731.234-9.259-8.643-12.88-16.242-12.116Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.55,
      d: "M38.211 11.232v4.537c0 2.693-.948 5.154-2.53 7.081a11.022 11.022 0 0 1-8.545 4.053c-3.983 0-7.474-2.114-9.423-5.286h-.005a11.1 11.1 0 0 1-1.65-5.848v-4.537C16.062 5.082 21.02.097 27.137.097a11 11 0 0 1 7.83 3.262 11.12 11.12 0 0 1 3.245 7.873Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.85,
      d: "M23.635 13.554c.165-1.035-.432-1.991-1.333-2.136-.901-.145-1.765.576-1.93 1.61-.164 1.035.433 1.992 1.334 2.136.9.146 1.765-.576 1.93-1.61ZM32.56 15.163c.9-.145 1.498-1.101 1.333-2.136-.165-1.034-1.029-1.756-1.93-1.61-.9.144-1.498 1.1-1.333 2.135.165 1.034 1.029 1.756 1.93 1.61Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.75,
      d: "M29.856 18.723c-.296-.695-.994-.891-2.193-.465-.404.131-.81.131-1.215 0-1.198-.426-1.896-.23-2.192.465-.164.384-.148.816-.019 1.212.237.729.727 1.314 1.678 1.638.736.25 1.544.25 2.28 0 .95-.322 1.44-.907 1.677-1.638.13-.396.145-.83-.018-1.212h.002Z",
      fill: "#65BFF1"
    }
  )
] });
const ForwardRef = forwardRef(SvgDog);
export {
  ForwardRef as default
};
